import React from 'react';
import PropTypes from 'prop-types';
import { LuCopy, LuPencil } from 'react-icons/lu';
import { Button, PersonChip } from 'components/common';
import { FLOW_SECTIONS, FLOW_TYPES, getCodes, roleKey } from './processFlowSchema';

const People = ({ codes }) => (
  codes.length === 0
    ? <span className="tw-text-slate-300">—</span>
    : (
      <div className="tw-flex tw-flex-wrap tw-gap-x-3 tw-gap-y-1">
        {codes.map((code) => <PersonChip key={code} name={code} size="xs" />)}
      </div>
    )
);

People.propTypes = { codes: PropTypes.arrayOf(PropTypes.string).isRequired };

const cellBorder = 'tw-border-0 tw-border-t tw-border-solid tw-border-slate-100';

// Roles as rows, Build up / Hot roll as columns: 16 roles × 2 flows reads far
// better than a 16-column matrix that needs horizontal scrolling.
const SalesUnitProcessFlow = ({ salesUnit, onEdit, onApply }) => (
  <>
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mb-3">
      <h6 className="tw-text-[11px] tw-font-bold tw-text-primary-600 tw-uppercase tw-tracking-wider tw-mb-0">Process flow</h6>
      <div className="tw-flex tw-gap-2">
        <Button size="sm" variant="secondary" leftIcon={LuCopy} onClick={onApply}>Apply to sales units</Button>
        <Button size="sm" variant="primary" leftIcon={LuPencil} onClick={onEdit}>Edit process flow</Button>
      </div>
    </div>

    <div className="tw-overflow-x-auto tw-border tw-border-solid tw-border-slate-200 tw-rounded">
      <table className="tw-w-full tw-text-sm tw-border-collapse">
        <thead>
          <tr className="tw-bg-slate-50 tw-text-[11px] tw-uppercase tw-tracking-wide tw-text-slate-500">
            <th className="tw-px-3 tw-py-2 tw-text-left tw-font-semibold tw-w-56">Role</th>
            {FLOW_TYPES.map((type) => (
              <th key={type.key} className="tw-px-3 tw-py-2 tw-text-left tw-font-semibold">{type.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {FLOW_SECTIONS.map((section) => (
            <React.Fragment key={section.key}>
              <tr className="tw-bg-slate-50/60">
                <td colSpan={FLOW_TYPES.length + 1} className={`${cellBorder} tw-px-3 tw-py-1.5 tw-text-xs tw-font-bold tw-text-slate-700`}>
                  {section.label}
                </td>
              </tr>
              {section.roles.map((role) => (
                <tr key={roleKey(role.path)}>
                  <td className={`${cellBorder} tw-px-3 tw-py-2 tw-pl-6 tw-text-slate-600 tw-whitespace-nowrap tw-align-top`}>{role.label}</td>
                  {FLOW_TYPES.map((type) => (
                    <td key={type.key} className={`${cellBorder} tw-px-3 tw-py-2 tw-align-top`}>
                      <People codes={getCodes(salesUnit[type.key], role.path)} />
                    </td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  </>
);

SalesUnitProcessFlow.propTypes = {
  salesUnit: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default SalesUnitProcessFlow;
